import React from 'react';
import { industries } from '../mock';
import * as LucideIcons from 'lucide-react';

const IndustriesSection = () => {
  const getIcon = (iconName) => {
    const Icon = LucideIcons[iconName];
    return Icon ? <Icon size={32} /> : <LucideIcons.Building size={32} />;
  };

  return (
    <section className="industries-section" id="industries">
      <div className="section-container">
        <div className="section-header-center">
          <span className="section-label">Industries We Serve</span>
          <h2 className="section-title">
            Trademark Protection
            <span className="title-highlight"> Across All Industries</span>
          </h2>
          <p className="section-description">
            From startups to established enterprises, we provide specialized trademark 
            registration services across diverse industries. Our expertise spans every 
            business sector, ensuring your brand receives industry-specific protection.
          </p>
        </div>

        <div className="industries-grid">
          {industries.map((industry, index) => (
            <div key={index} className="industry-card">
              <div className="industry-icon">
                {getIcon(industry.icon)}
              </div>
              <h3 className="industry-name">{industry.name}</h3>
            </div>
          ))}
        </div>

        <div className="industries-footer">
          <p className="industries-footer-text">
            Don't see your industry listed? We work with businesses across all sectors. 
            <strong> Every industry deserves brand protection.</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
